import Menu from '~icons/material-symbols/menu'
import { memo, useContext, useCallback } from 'react'
import { CrewSortableUnorderedListItemContext } from '../crewSortableUnorderedListItem/crewSortableUnorderedListItem'

// Drag handle item for unordered list
export const CrewDragHandleForUnorderedList = memo(() => {
  const { attributes, listeners } = useContext(
    CrewSortableUnorderedListItemContext
  )

  // クリックイベントの伝播を止める
  const handleClick = useCallback((e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
  }, [])

  return (
    <span
      {...attributes}
      {...listeners}
      onClick={handleClick}
      className="cursor-grab active:cursor-grabbing"
    >
      <Menu width={24} height={24} />
    </span>
  )
})
